module.exports = __webpack_public_path__ + "static/media/sleep-and-relaxation-large.7be24001.png";